// Campus photo for /colleges/rochester-institute-of-technology: CC BY-SA 4.0, by Stilfehler, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ARochester_Institute_of_Technology_72.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/rochester-institute-of-technology/; credited under the photo.
const photo = {
    "slug": "rochester-institute-of-technology",
    "alt": "Brick campus buildings, trees and a tall rust-colored steel sculpture on a paved plaza at Rochester Institute of Technology",
    "src": "/colleges/rochester-institute-of-technology/campus-1600.webp",
    "srcSmall": "/colleges/rochester-institute-of-technology/campus-800.webp",
    "srcMid": "/colleges/rochester-institute-of-technology/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/rochester-institute-of-technology/og.jpg",
    "title": "Rochester Institute of Technology 72",
    "author": "Stilfehler",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ARochester_Institute_of_Technology_72.jpg",
    "read": "2026-10-01"
};

export default photo;
